// VideoPlayerStates goes from initializing -> ready
export enum VideoPlayerState {
  UNINITIALIZED,
  INITIALIZING,
  READY,
}
